"use strict";

require("core-js/modules/es6.regexp.replace");

module.exports = function (value) {
  return value.replace(/\w\S*/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  });
};